import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import { useAuth } from "../../context/AuthContext";
import { getAllPurohitProfiles } from "../../services/api";
import PaymentGateway from "../PaymentGateway";
import {
  userWallet,
  purohitUnlock,
  unlockId,
  userplatformFees
} from "../../services/api";


import {
  MapPin,
  X,
  Phone,
  Mail,
  Star,
  Lock,
  Unlock,
  Award,
  Languages,
  Users,
} from "lucide-react";

export default function PandithParichayaPage() {
  const navigate = useNavigate();
  const { auth } = useAuth();

  const currentUserId = auth?.user?.id;
  const isPurohit = auth?.role === "purohit";

  const [searchQuery, setSearchQuery] = useState("");
  const [selectedPurohit, setSelectedPurohit] = useState(null);
  const [currentView, setCurrentView] = useState("list");
  const [unlockedIds, setUnlockedIds] = useState([]);
  const [justUnlockedId, setJustUnlockedId] = useState(null);
  



  const [loading, setLoading] = useState(true);

  const [purohits, setPurohits] = useState([]);
  const [filteredPurohits, setFilteredPurohits] = useState([]);

  const [wallet, setWallet] = useState(null);
 
  const [isUnlocking, setIsUnlocking] = useState(false);
  const [paying, setPaying] = useState(false);

const isUnlocked = (purohitId) =>
  purohitId === justUnlockedId ||
  unlockedIds.some(
    (u) =>
      Number(u.purohitId) === Number(purohitId) &&
      (!u.expiresAt || new Date(u.expiresAt) > new Date())
  );




  const isLoggedIn = auth.isAuthenticated;

  const handleSearchChange = (e) => {
    const value = e.target.value;

    const regex = /^[A-Za-z]*$/;

    if (regex.test(value)) {
      setSearchQuery(value);
    }
  };

  // 🔐 Role-based card visibility
  const roleBasedPurohits =
    auth?.role === "purohit"
      ? filteredPurohits.filter(
          (p) => (p.userId || p.user?.id || p.id || p._id) === currentUserId
        )
      : filteredPurohits;

  useEffect(() => {
    const fetchPurohits = async () => {
      try {
        setLoading(true);
        const response = await getAllPurohitProfiles();

        let profiles = [];

        if (Array.isArray(response.data)) {
          profiles = response.data;
        } else if (
          typeof response.data === "object" &&
          response.data !== null
        ) {
          if (response.data.data && Array.isArray(response.data.data)) {
            profiles = response.data.data;
          } else if (
            response.data.profiles &&
            Array.isArray(response.data.profiles)
          ) {
            profiles = response.data.profiles;
          } else if (
            response.data.purohits &&
            Array.isArray(response.data.purohits)
          ) {
            profiles = response.data.purohits;
          } else if (response.data.message && response.data.data) {
            profiles = Array.isArray(response.data.data)
              ? response.data.data
              : [];
          } else {
            console.error("❌ No array found in response");

            profiles = [];
          }
        } else {
          console.error("❌ Unexpected response type");
          profiles = [];
        }

        const formattedProfiles = profiles.map((p) => ({
          ...p,
          experience: `${p.experienceYears} Years`,
          about: p.biography,
        }));

        setPurohits(formattedProfiles);
        setFilteredPurohits(formattedProfiles);
      } catch (error) {
        console.error("Error fetching purohit profiles:", error);
        console.error("Error details:", error.response?.data);
        toast.error("Failed to load purohit profiles", {
          duration: 3000,
        });
      } finally {
        setLoading(false);
      }
    };

    fetchPurohits();
  }, []);

 

 

  useEffect(() => {
    if (!searchQuery.trim()) {
      setFilteredPurohits(purohits);
      return;
    }

    const query = searchQuery.toLowerCase();

    const filtered = purohits.filter((purohit) => {
      const nameMatch = purohit.fullName.toLowerCase().includes(query);
      const cityMatch = purohit.city.toLowerCase().includes(query);
      const stateMatch = purohit.state?.toLowerCase().includes(query);
      const specializationMatch = purohit.specializations?.some((spec) =>
        spec.toLowerCase().includes(query)
      );
      const languageMatch = purohit.languages?.some((lang) =>
        lang.toLowerCase().includes(query)
      );

      return (
        nameMatch ||
        cityMatch ||
        stateMatch ||
        specializationMatch ||
        languageMatch
      );
    });

    setFilteredPurohits(filtered);
  }, [searchQuery, purohits]);

  useEffect(() => {
    document.body.style.overflow =
      selectedPurohit || currentView !== "list" ? "hidden" : "";
  }, [selectedPurohit, currentView]);

    useEffect(() => {
    if (!auth.isAuthenticated) return;

    const loadWalletAndUnlocks = async () => {
      try {
        const [walletRes, unlockRes] = await Promise.all([
          userWallet(),
          purohitUnlock(),
        ]);

        setWallet(walletRes.data);

        const unlockList = Array.isArray(unlockRes?.data?.unlocks)
  ? unlockRes.data.unlocks
  : [];

const validUnlocks = unlockList.filter(
  (u) => !u.expiresAt || new Date(u.expiresAt) > new Date()
);

setUnlockedIds(validUnlocks);


       
      } catch (err) {
        console.error("Failed to load wallet/unlocks", err);
      }
    };

    loadWalletAndUnlocks();
  }, [auth.isAuthenticated]);

const handleConnect = (purohit) => {
  if (!auth.isAuthenticated) {
    toast.error("Please login to continue");
    navigate("/login", { state: { returnTo: "/pandith-parichaya" } });
    return;
  }

  setSelectedPurohit(purohit);
  setCurrentView("details"); // 🔥 REQUIRED
};


  

  const handleCopyContact = (type, value) => {
    navigator.clipboard.writeText(value);
    toast.success(`${type} copied to clipboard!`, {
      icon: "📋",
      duration: 2000,
    });
  };

  const handleBookCall = () => {
    toast.success("Call request sent to purohit!", {
      icon: "📞",
      duration: 3000,
    });
  };

  const handleBookEmail = () => {
    toast.success("Email request sent!", {
      icon: "✉️",
      duration: 3000,
    });
  };

  const closeModal = () => {
    setSelectedPurohit(null);
    setCurrentView("list");
     setJustUnlockedId(null);
  };

  const clearSearch = () => {
    setSearchQuery("");
  };

  const renderPaymentModal = () => (
    <PaymentGateway
      amount="5"
      userDetails={{
        name: auth?.user?.fullName || auth?.user?.name || "User",
        email: auth?.user?.email || "user@example.com",
        phone: auth?.user?.phone || "+91 00000 00000",
      }}
      paymentType="purohit_unlock"
      metadata={{
        purohitId: selectedPurohit?._id || selectedPurohit?.id,
      }}




// onSuccess={async () => {
//   try {
//     toast.success("Payment successful");

//     // 1️⃣ Add credits
//     await userplatformFees({});

//     // 2️⃣ Refresh wallet
//     const walletRes = await userWallet();
//     setWallet(walletRes.data);

//     // 3️⃣ Unlock purohit
//     const purohitId = selectedPurohit._id || selectedPurohit.id;
//     await unlockId(purohitId);

//     // 🔥 INSTANT UNMASK (NO WAITING)
//     setJustUnlockedId(purohitId);

//     // 4️⃣ Sync from backend
//     const unlockRes = await purohitUnlock();
//     setUnlockedIds(unlockRes.data?.unlocks || []);

//     // 5️⃣ Stay on modal
//     setCurrentView("details");
//     setSelectedPurohit((prev) => ({ ...prev }));
//   } catch (err) {
//     toast.error("Payment succeeded but unlock failed");
//   }
// }}

onSuccess={async () => {

  if (paying) return;        // 🛑 prevent double run
  setPaying(true);
  try {
    toast.success("Payment successful");

    // 1️⃣ Add credits
    await userplatformFees({});

    // 2️⃣ Reload wallet
    const walletRes = await userWallet();
    setWallet(walletRes.data);

    // 3️⃣ Unlock purohit
    const purohitId = selectedPurohit._id || selectedPurohit.id;
    await unlockId(purohitId);

    setJustUnlockedId(purohitId);

    const unlockRes = await purohitUnlock();
    setUnlockedIds(unlockRes.data?.unlocks || []);

    setCurrentView("details");
  } catch (err) {
    toast.error(
      err.response?.data?.message ||
      "Something went wrong after payment"
    );
  }
}}






      onClose={() => {
        setCurrentView("list");
      }}
      onPaymentSubmit={async (paymentData) => {
        console.log("Submitting payment:", paymentData);
      }}
      title="Unlock Purohit Contacts"
      description="Pay ₹5 to unlock contact details of a purohit (credits valid for 1 month)"
    />
  );


 

//   const handleUnlock = async () => {
//     const purohitId = selectedPurohit._id || selectedPurohit.id;
//     if (isUnlocking || isUnlocked(purohitId)) return;

// setIsUnlocking(true);


//     try {
//       // Credit available → unlock directly
//       if (wallet?.remainingCredits > 0) {
//         await unlockId(purohitId);

//         toast.success("Purohit unlocked successfully");

//      const unlockRes = await purohitUnlock();
// const unlockList = unlockRes.data?.unlocks || [];

// const validUnlocks = unlockList.filter(
//   (u) => !u.expiresAt || new Date(u.expiresAt) > new Date()
// );

// setUnlockedIds(validUnlocks);


//         // setWallet((prev) => ({
//         //   ...prev,
//         //   usedCredits: prev.usedCredits + 1,
//         //   remainingCredits: prev.remainingCredits - 1,
//         // }));

//         setWallet((prev) =>
//           prev
//             ? {
//                 ...prev,
//                 usedCredits: prev.usedCredits + 1,
//                 remainingCredits: prev.remainingCredits - 1,
//               }
//             : prev
//         );

//         return;
//       }

//       // No credits → open payment
//       setCurrentView("payment");
//     } catch (err) {
//       toast.error("Unable to unlock purohit");
//     }
//     finally {
//   setIsUnlocking(false);
// }

//   };



const handleUnlock = async () => {
  const purohitId = selectedPurohit._id || selectedPurohit.id;
  if (isUnlocking || isUnlocked(purohitId)) return;

  setIsUnlocking(true);

  try {
    // ✅ Always trust backend wallet
    const walletRes = await userWallet();

    if (walletRes.data.remainingCredits > 0) {
      await unlockId(purohitId);

      toast.success("Purohit unlocked successfully");

      // 🔄 Reload unlocks
      const unlockRes = await purohitUnlock();
      setUnlockedIds(unlockRes.data?.unlocks || []);

      // 🔄 Reload wallet (IMPORTANT)
      const updatedWallet = await userWallet();
      setWallet(updatedWallet.data);

      return;
    }

    // ❌ No credits → open payment
    setCurrentView("payment");
  } catch (err) {
    toast.error("Unable to unlock purohit");
  } finally {
    setIsUnlocking(false);
  }
};

  const renderDetailsModal = () => {
    const purohitId = selectedPurohit._id || selectedPurohit.id;
    const unlocked = isPurohit || isUnlocked(purohitId);

    return (
      <div className="fixed inset-0 bg-black/70 backdrop-blur-sm z-50 flex items-center justify-center p-4">
        <div className="bg-white w-full max-w-4xl rounded-3xl shadow-2xl overflow-hidden max-h-[90vh]">
          {/* Header */}
          <div className="bg-gradient-to-r from-orange-500 to-red-500 text-white px-6 py-5 flex justify-between items-center">
            <div className="flex items-center gap-4">
              <div className="w-14 h-14 rounded-full overflow-hidden border-3 border-white shadow-lg">
                {selectedPurohit.profilePhotoUrl ? (
                  <img
                    src={selectedPurohit.profilePhotoUrl}
                    alt={selectedPurohit.fullName}
                    className="w-full h-full object-cover"
                  />
                ) : (
                  <div className="w-full h-full bg-white/20 flex items-center justify-center text-3xl">
                    🕉️
                  </div>
                )}
              </div>
              <div>
                <h1 className="text-2xl font-bold">
                  {selectedPurohit.fullName}
                </h1>
                <div className="flex items-center gap-4 mt-1 text-sm">
                  <span className="flex items-center gap-1">
                    <MapPin size={14} />
                    {selectedPurohit.city}
                  </span>
                  <span>•</span>
                  <span>{selectedPurohit.experienceYears} Years</span>
                </div>
              </div>
            </div>

            <button
              onClick={closeModal}
              className="p-2 rounded-full bg-white/20 hover:bg-white/30 transition-colors"
            >
              <X size={22} />
            </button>
          </div>

          <div className="overflow-y-auto max-h-[calc(90vh-100px)] p-6">
            <div className="grid lg:grid-cols-3 gap-6">
              <div className="lg:col-span-2 space-y-5">
                <div className="bg-orange-50 p-5 rounded-2xl border border-orange-100">
                  <h2 className="text-lg font-bold text-gray-900 mb-3">
                    About
                  </h2>
                  <p className="text-gray-700 leading-relaxed">
                    {selectedPurohit.biography}
                  </p>
                </div>

                {/* Achievements */}
                {selectedPurohit.achievements && (
                  <div className="bg-amber-50 p-5 rounded-2xl border border-amber-100">
                    <h2 className="text-lg font-bold text-gray-900 mb-3 flex items-center gap-2">
                      <Award className="text-amber-600" size={20} />
                      Achievements
                    </h2>
                    <p className="text-gray-700 leading-relaxed">
                      {selectedPurohit.achievements}
                    </p>
                  </div>
                )}

                {/* Specializations */}
                <div className="bg-blue-50 p-5 rounded-2xl border border-blue-100">
                  <h2 className="text-lg font-bold text-gray-900 mb-3">
                    Specializations
                  </h2>
                  <div className="flex flex-wrap gap-2">
                    {selectedPurohit.specializations?.map((spec, index) => (
                      <span
                        key={index}
                        className="px-4 py-2 bg-white text-gray-800 rounded-xl border border-orange-200 font-medium text-sm"
                      >
                        {spec}
                      </span>
                    ))}
                  </div>
                </div>

                {/* Languages */}
                <div className="bg-green-50 p-5 rounded-2xl border border-green-100">
                  <h2 className="text-lg font-bold text-gray-900 mb-3 flex items-center gap-2">
                    <Languages className="text-green-600" size={20} />
                    Languages Spoken
                  </h2>
                  <div className="flex flex-wrap gap-2">
                    {selectedPurohit.languages?.map((lang, index) => (
                      <span
                        key={index}
                        className="px-4 py-2 bg-white text-gray-800 rounded-xl border border-green-200 font-medium text-sm"
                      >
                        {lang}
                      </span>
                    ))}
                  </div>
                </div>
              </div>

              {/* Right Column */}
              {isPurohit ? (
                /* ================= PUROHIT PROFILE SUMMARY ================= */
                <div className="lg:col-span-1">
                  <div className="bg-gradient-to-br from-orange-50 to-red-50 rounded-2xl p-5 border-2 border-orange-200 shadow-lg sticky top-0">
                    <h3 className="text-lg font-bold text-gray-900 mb-4">
                      Profile Summary
                    </h3>

                    {/* Experience */}
                    <div className="mb-3">
                      <p className="text-sm text-gray-500">Experience</p>
                      <p className="font-semibold text-gray-800">
                        {selectedPurohit.experienceYears} Years
                      </p>
                    </div>

                    {/* Address */}
                    <div className="mb-3">
                      <p className="text-sm text-gray-500">Location</p>
                      <p className="font-semibold text-gray-800">
                        {selectedPurohit.city}, {selectedPurohit.state}
                      </p>
                    </div>

                    {/* Services Offered */}
                    {selectedPurohit.servicesOffered?.length > 0 && (
                      <div className="mb-3">
                        <p className="text-sm text-gray-500 mb-1">
                          Services Offered
                        </p>
                        <div className="flex flex-wrap gap-2">
                          {selectedPurohit.servicesOffered.map(
                            (service, index) => (
                              <span
                                key={index}
                                className="px-3 py-1 bg-white border border-orange-200 rounded-lg text-sm font-medium text-gray-800"
                              >
                                {service}
                              </span>
                            )
                          )}
                        </div>
                      </div>
                    )}

                    {/* Languages */}
                    {selectedPurohit.languages?.length > 0 && (
                      <div className="mb-3">
                        <p className="text-sm text-gray-500 mb-1">Languages</p>
                        <div className="flex flex-wrap gap-2">
                          {selectedPurohit.languages.map((lang, index) => (
                            <span
                              key={index}
                              className="px-3 py-1 bg-white border border-green-200 rounded-lg text-sm font-medium text-gray-800"
                            >
                              {lang}
                            </span>
                          ))}
                        </div>
                      </div>
                    )}

                    {/* Specializations */}
                    {selectedPurohit.specializations?.length > 0 && (
                      <div className="mb-3">
                        <p className="text-sm text-gray-500 mb-1">
                          Specializations
                        </p>
                        <div className="flex flex-wrap gap-2">
                          {selectedPurohit.specializations.map(
                            (spec, index) => (
                              <span
                                key={index}
                                className="px-3 py-1 bg-white border border-blue-200 rounded-lg text-sm font-medium text-gray-800"
                              >
                                {spec}
                              </span>
                            )
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              ) : (
                /* ================= USER CONTACT / UNLOCK FLOW ================= */
                <div className="lg:col-span-1">
                  <div className="bg-gradient-to-br from-orange-50 to-red-50 rounded-2xl p-5 border-2 border-orange-200 shadow-lg sticky top-0">
                    <div className="flex items-center justify-between mb-4">
                      <h3 className="text-lg font-bold text-gray-900">
                        Contact Info
                      </h3>
                      {!unlocked && (
                        <div className="bg-orange-600 text-white p-1.5 rounded-full">
                          <Lock size={14} />
                        </div>
                      )}
                    </div>

                    {/* Phone */}
                    <div className="mb-4">
                      <p className="text-sm text-gray-500 mb-2 flex items-center gap-1">
                        <Phone size={14} />
                        Phone
                      </p>
                      {unlocked ? (
                        <>
                          <p className="font-semibold text-gray-800 mb-2">
                            {selectedPurohit.phone}
                          </p>
                          <button
                            onClick={() =>
                              handleCopyContact("Phone", selectedPurohit.phone)
                            }
                            className="text-xs bg-orange-100 text-orange-700 px-3 py-1.5 rounded-lg hover:bg-orange-200 font-medium transition-colors w-full"
                          >
                            Copy
                          </button>
                        </>
                      ) : (
                        <div className="relative">
                          <p className="font-semibold text-gray-800 blur-sm select-none">
                            +91 98765 43210
                          </p>
                        </div>
                      )}
                    </div>

                    {/* Email */}
                    <div className="mb-4">
                      <p className="text-sm text-gray-500 mb-2 flex items-center gap-1">
                        <Mail size={14} />
                        Email
                      </p>
                      {unlocked ? (
                        <>
                          <p className="font-semibold text-gray-800 mb-2 break-all">
                            {selectedPurohit.email}
                          </p>
                          <button
                            onClick={() =>
                              handleCopyContact("Email", selectedPurohit.email)
                            }
                            className="text-xs bg-orange-100 text-orange-700 px-3 py-1.5 rounded-lg hover:bg-orange-200 font-medium transition-colors w-full"
                          >
                            Copy
                          </button>
                        </>
                      ) : (
                        <div className="relative">
                          <p className="font-semibold text-gray-800 blur-sm select-none break-all">
                            contact@example.com
                          </p>
                        </div>
                      )}
                    </div>

                    {/* Buttons */}
                    {unlocked ? (
                      <div className="space-y-2">
                        <button
                          onClick={handleBookCall}
                          className="w-full py-2.5 bg-gradient-to-r from-green-500 to-green-600 text-white rounded-xl font-semibold hover:from-green-600 hover:to-green-700 flex items-center justify-center gap-2 shadow-md hover:shadow-lg transition-all text-sm"
                        >
                          <Phone size={16} />
                          Book Call
                        </button>
                        <button
                          onClick={handleBookEmail}
                          className="w-full py-2.5 bg-gradient-to-r from-blue-500 to-blue-600 text-white rounded-xl font-semibold hover:from-blue-600 hover:to-blue-700 flex items-center justify-center gap-2 shadow-md hover:shadow-lg transition-all text-sm"
                        >
                          <Mail size={16} />
                          Send Email
                        </button>
                      </div>
                    ) : (
                      <div className="space-y-3">
                        <div className="bg-yellow-50 border border-yellow-200 rounded-xl p-3 text-center">
                          <Lock
                            className="mx-auto mb-2 text-yellow-600"
                            size={24}
                          />
                          <p className="text-sm font-semibold text-gray-700">
                            Contact Locked
                          </p>
                        </div>
                        <button
                          onClick={handleUnlock}
                          className="w-full py-2.5 bg-gradient-to-r from-orange-500 to-red-500 text-white rounded-xl font-semibold hover:opacity-90 transition-all shadow-md"
                        >
                          Unlock Contact (₹5)
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="w-full min-h-screen bg-gradient-to-b from-orange-50 via-white to-orange-50 overflow-x-hidden pt-20">
      {currentView === "payment" && renderPaymentModal()}

{selectedPurohit && currentView === "details" && (
  <React.Fragment
    key={`${selectedPurohit._id || selectedPurohit.id}-${isUnlocked(
      selectedPurohit._id || selectedPurohit.id
    )}`}
  >
    {renderDetailsModal()}
  </React.Fragment>
)}



      <div
        className="w-full pt-20 pb-40 text-center text-white relative"
        style={{
          background:
            "linear-gradient(180deg, rgba(255,152,0,0.30), rgba(255,90,0,0.30), rgba(227,53,0,0.30)), url('https://i.pinimg.com/736x/01/a5/8a/01a58a9a1328529c61692161b0bc408c.jpg') center / cover no-repeat",
        }}
      >
        <h1 className="text-5xl font-serif font-bold drop-shadow-lg">
          Pandith Parichaya
        </h1>

        <p className="mt-5 text-lg max-w-3xl mx-auto opacity-90 leading-relaxed px-4">
          Connect with verified and experienced purohits for authentic Hindu
          ceremonies and rituals.
        </p>

        <div className="mt-8 w-full flex flex-col items-center px-4">
          <div className="w-full max-w-3xl flex justify-center">
            <div className="bg-white/90 backdrop-blur-md w-full rounded-full px-5 py-4 flex items-center shadow-lg border border-white/40 relative">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-5 h-5 text-gray-400 mr-3"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M21 21l-3.5-3.5m0 0A7.5 7.5 0 1010.5 18a7.5 7.5 0 007.5-7.5z"
                />
              </svg>

              <input
                type="text"
                placeholder="Search by city, specialization, language..."
                value={searchQuery}
                onChange={handleSearchChange}
                className="flex-1 bg-transparent outline-none text-gray-700 placeholder-gray-400 text-[15px]"
              />

              {searchQuery && (
                <button
                  onClick={clearSearch}
                  className="mr-2 p-1 hover:bg-gray-100 rounded-full transition-colors"
                >
                  <X size={18} className="text-gray-500" />
                </button>
              )}

              <div className="w-9 h-9 rounded-full bg-gradient-to-r from-orange-500 to-red-500 shadow flex items-center justify-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={2}
                  stroke="white"
                  className="w-5 h-5"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M21 21l-3.5-3.5m0 0A7.5 7.5 0 1010.5 18a7.5 7.5 0 007.5-7.5z"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>

        <div className="absolute bottom-0 left-0 w-full overflow-hidden">
          <svg viewBox="0 0 1440 80" className="w-full">
            <path
              d="M0 40 C 350 70, 650 10, 1000 40 C 1200 55, 1400 35, 1440 40 L1440 80 L0 80 Z"
              fill="#fff7ed"
            />
          </svg>
        </div>
      </div>

      {/* Loading State */}
      {loading && (
        <div className="max-w-7xl mx-auto px-10 mt-14">
          <div className="text-center py-20">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-orange-100 rounded-full mb-6">
              <div className="w-8 h-8 border-4 border-orange-500 border-t-transparent rounded-full animate-spin"></div>
            </div>
            <h3 className="text-2xl font-semibold text-gray-800 mb-3">
              Loading Purohits...
            </h3>
          </div>
        </div>
      )}

      {/* COUNT & SEARCH STATUS */}
      {!loading && (
        <div className="max-w-7xl mx-auto px-10 mt-14">
          {filteredPurohits.length > 0 ? (
            <>
              {!isPurohit && (
                <div className="text-gray-700 text-lg">
                  {searchQuery ? (
                    <>
                      Found <b>{filteredPurohits.length}</b> purohit
                      {filteredPurohits.length !== 1 ? "s" : ""} matching "
                      {searchQuery}"
                    </>
                  ) : (
                    <>
                      Showing <b>{filteredPurohits.length}</b> verified purohit
                      {filteredPurohits.length !== 1 ? "s" : ""}
                    </>
                  )}
                  {!isLoggedIn && (
                    <span className="ml-4 text-sm text-orange-600">
                      <button
                        onClick={() =>
                          navigate("/login", {
                            state: { returnTo: "/pandith-parichaya" },
                          })
                        }
                        className="underline hover:text-orange-700 font-medium"
                      >
                        Login
                      </button>{" "}
                      to connect with purohits
                    </span>
                  )}
                </div>
              )}
            </>
          ) : (
            <div className="text-center py-20">
              <div className="inline-flex items-center justify-center w-24 h-24 bg-orange-100 rounded-full mb-6">
                <Users size={48} className="text-orange-500" />
              </div>
              <h3 className="text-2xl font-semibold text-gray-800 mb-3">
                {searchQuery
                  ? `No Purohits Found for "${searchQuery}"`
                  : "No Purohits Available Yet"}
              </h3>
              <p className="text-gray-600 text-lg max-w-md mx-auto">
                {searchQuery ? (
                  <>
                    Try searching with different keywords like city names,
                    specializations, or languages.
                    <button
                      onClick={clearSearch}
                      className="block mx-auto mt-4 text-orange-600 hover:text-orange-700 font-semibold underline"
                    >
                      Clear Search
                    </button>
                  </>
                ) : (
                  "We're waiting for verified purohits to complete their profiles. Check back soon!"
                )}
              </p>
            </div>
          )}
        </div>
      )}

      {/* CARDS GRID */}
      {!loading && filteredPurohits.length > 0 && (
        <div className="max-w-7xl mx-auto px-4 py-8 pb-20">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
            {roleBasedPurohits.map((p) => {
              const purohitId = p._id || p.id;

              const unlocked = isUnlocked(purohitId);

              return (
                <div
                  key={purohitId}
                  className={`relative group bg-white rounded-2xl overflow-hidden shadow-lg transition-all duration-300 cursor-pointer border
  ${unlocked ? "border-green-500" : "border-gray-200"}
  ${!unlocked && !isPurohit ? "opacity-70" : ""}
`}
                >
                  <div className="absolute top-3 right-3 z-20">
                    {!isPurohit && !unlocked ? (
                      <div className="bg-gray-800 text-white p-1.5 rounded-full">
                        <Lock size={14} />
                      </div>
                    ) : unlocked && !isPurohit ? (
                      <div className="bg-green-600 text-white p-1.5 rounded-full">
                        <Unlock size={14} />
                      </div>
                    ) : null}
                  </div>

                  <div className="relative h-44 overflow-hidden">
                    <div
                      className={`absolute inset-0 bg-cover bg-center scale-100
  ${unlocked || isPurohit ? "blur-sm" : "blur-md"}
`}
                      style={{
                        backgroundImage: p.profilePhotoUrl
                          ? `url(${p.profilePhotoUrl})`
                          : "linear-gradient(135deg, #f6d365 0%, #fda085 100%)",
                      }}
                    />

                    <div className="absolute inset-0 bg-gradient-to-b from-black/10 via-black/20 to-white"></div>

                    <div className="absolute inset-0 flex items-center justify-center">
                      <div className="relative">
                        <div className="w-32 h-32 rounded-full overflow-hidden border-4 border-gray-300 shadow-xl bg-white">
                          {p.profilePhotoUrl ? (
                            <img
                              src={p.profilePhotoUrl}
                              alt={p.fullName}
                              className="w-full h-full object-cover"
                            />
                          ) : (
                            <div className="w-full h-full bg-gradient-to-br from-orange-100 to-red-100 flex items-center justify-center text-5xl">
                              🕉️
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Content Section */}
                  <div className="p-5 text-center bg-white">
                    {/* Name */}
                    <h3 className="text-xl font-semibold text-gray-900 group-hover:text-orange-600 transition-colors mb-1">
                      {p.fullName}
                    </h3>

                    {/* Location */}
                    <div className="flex justify-center items-center gap-1 text-gray-600 mb-2">
                      <MapPin size={16} className="text-orange-500" />
                      <span className="text-sm font-medium">
                        {p.city}, {p.state}
                      </span>
                    </div>

                    {/* Rating + Experience */}
                    <div className="flex items-center justify-center gap-4 text-sm mt-1">
                      {/* Stars */}
                      <div className="flex gap-0.5">
                        {Array(4)
                          .fill(0)
                          .map((_, i) => (
                            <Star
                              key={i}
                              size={16}
                              className="fill-orange-400 text-orange-400"
                            />
                          ))}
                      </div>

                      <span className="text-gray-300">|</span>

                      {/* Experience */}
                      <span className="text-gray-800 font-medium">
                        {p.experienceYears} Years
                      </span>
                    </div>

                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        handleConnect(p);
                      }}
                      className="mt-4 mb-1 w-full py-2.5 bg-gradient-to-r from-orange-500 to-red-500 text-white rounded-full font-semibold text-sm hover:opacity-90 transition-all shadow-sm"
                    >
                      View Details
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* 🔓 Bottom Unlock Bar */}
    </div>
  );
}
